import Vue from 'vue';
import Router from 'vue-router';
import index from '../view/problemFeedback/index';
import feedbackRecord from '../view/feedbackRecord/index';
import feedbackDetails from '../view/feedbackDetails/index';
Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/feedbackRecord',
      name: 'feedbackRecord',
      component: feedbackRecord
    },
    {
      path: '/feedbackDetails',
      name: 'feedbackDetails',
      component: feedbackDetails
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js